<app-student-list [iIsArchived]="true"></app-student-list>
